import firstPizza from "../../../../images/piazzajpg.jpg";
export const pizzaData = [
  {
    name: "Chicken Pizza",
    image: firstPizza,
    price: "12.50",
    description: "chicken patty,BBQ sauce,tomato",
    ingredients: ["BBQ sauce", "Anything", "Spirit "],
    addOns: [
      { name: "Tommato", price: "5.00", quantity: 0 },
      { name: "Nijerian Pudina", price: "2.00", quantity: 0 },
    ],
  },
  {
    name: "Kuchu puchu pizza",
    image: firstPizza,
    price: "150.00",
    deletedprice: " 20",
    description: "cheese,Naga",
    ingredients: ["Indian onion"],
  },
  {
    name: "BBQ Pizza",
    image: firstPizza,
    price: "130.00",
    description: "beef patty, BBQ sauce,",
  },
  {
    name: "Kuchu puchu pizza",
    image: firstPizza,
    price: "150.50",
    deletedprice: " 20",
    description: "cheese,Naga",
  },
];
